<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />

    <v-snackbar v-model="showsnackbar" color="#00a972" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout px-2 wrap justify-center>
      <v-flex xs12 sm12 md8>
        <v-layout pt-2 wrap justify-start>
          <v-flex xs12 sm12 md12 text-center px-2>
            <span style="font-size:24px;font-weight:500;">Privacy Policy & Terms and Conditions</span>
          </v-flex>
          <v-flex xs12 sm6 md3 style="height:50px" px-2 pt-2>
            <v-select
              dense
              solo
              v-model="country"
              :items="countries"
              item-text="country"
              :return-object="true"
              label="Country"
              color="#1fb07c"
              item-color="#1fb07c"
            ></v-select>
          </v-flex>
          <v-flex v-if="dataRetrived" xs12 sm12 md12 text-justify px-2 pt-2>
            <span style="font-size:14px;font-weight:400;">{{country.tmcandpvp}}</span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      appLoading: false,
      showsnackbar: false,
      timeout: 5000,
      msg: null,
      ServerError: false,
      countries: [],
      country: null,
      dataRetrived: false
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/country/getlist"
      })
        .then(response => {
          this.appLoading = false;
          this.countries = response.data.data;
          this.country = this.countries[0];
          this.dataRetrived = true;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    }
  }
};
</script>